import { defineStore } from 'pinia';
import type { LinksType } from '@base/types/links';
import setQueryToUrl from '@base/utils/setQueryToUrl';

const useBaseStore = defineStore('base', () => {
  const linksData = ref<Record<string, string>>({});

  const setLinksData = (data: LinksType) => {
    linksData.value = {
      ourFooterLink: setQueryToUrl(data['Ссылка_наша_футер']),
      ourHeaderLink: setQueryToUrl(data['Ссылка_наша_хэдер']),
      clientHeaderLink: setQueryToUrl(data['Ссылка_клиент_хэдер']),
      sirenaLink: setQueryToUrl(data['Ссылка_сирена_блок']),
      agreementLink: setQueryToUrl(data['Ссылка_юрправила']),
      prizesIntegrationLink: setQueryToUrl(data['Ссылка_призы']),
      bannerIntegrationLink: setQueryToUrl(data['Ссылка_баннер']),
      rulesLink: setQueryToUrl(data['Ссылка_правила']),
    };
  };

  return {
    linksData,
    setLinksData,
  };
});

export default useBaseStore;
